import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { useParams } from "react-router-dom";
import { LandingData, normalizeLandingData } from "../core/buildLandingData";
import { safeFetch } from "@/api/safeFetch";

interface ProfesionalContextType {
  landingData: LandingData | null;
  setLandingData: Dispatch<SetStateAction<LandingData | null>>;
  loading: boolean;
  perfilId: number | null;
}

const ProfesionalContext = createContext<ProfesionalContextType | undefined>(
  undefined,
);

export const ProfesionalProvider = ({ children }: { children: ReactNode }) => {
  // Landing pública -> /landing/:id
  // Editor -> /editar-landing/:profesionalId/:profesionId/:perfilId
  const { id, perfilId } = useParams();

  const perfil = id ?? perfilId;
  const perfilIdNumber = perfil ? Number(perfil) : null;

  const [landingData, setLandingData] = useState<LandingData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!perfil) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        setLoading(true);

        const res = await safeFetch(`/api/landing/profesional/${perfil}`);

        if (!res.ok) {
          throw new Error("API error");
        }

        const raw = await res.json();

      

        const landing = normalizeLandingData(raw);


        setLandingData(landing);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [perfil]);

  return (
    <ProfesionalContext.Provider
      value={{
        landingData,
        setLandingData,
        loading,
        perfilId: perfilIdNumber,
      }}
    >
      {children}
    </ProfesionalContext.Provider>
  );
};

export const useProfesional = () => {
  const ctx = useContext(ProfesionalContext);

  if (!ctx) {
    throw new Error("useProfesional debe usarse dentro de ProfesionalProvider");
  }

  return ctx;
};
